import { Menu, Transition } from '@headlessui/react'
import { useLocation } from '@remix-run/react'
import { Fragment } from 'react'
import type { Language } from '~/types/api-client'
import i18nConfig from '~/i18n-config'
import { ArrowDownBigIcon } from '~/components/icons/ArrowDownBigIcon'

export function LanguageSelector(props: { locale: string; languages: Language[] }) {
  const location = useLocation()
  // const locales = ['en']
  const i18nlocales = i18nConfig.supportedLngs

  const locales = props.languages?.filter((lang) => i18nlocales.includes(lang.iso6391)) ?? []

  let localesList = locales.map(function (language) {
    let searchParams = new URLSearchParams(location.search)
    searchParams.set('lng', language.iso6391)

    return (
      <Menu.Item key={language.iso6391}>
        {({ active }) => (
          <a
            className={`${
              active ? 'bg-primary-150' : ''
            } flex flex-row justify-center gap-x-2 rounded-md px-2 py-2 text-center font-medium uppercase text-base-500`}
            onClick={() => (window.location.href = `${location.pathname}?${searchParams}`)}
          >
            <img
              src={`/images/locales/${language.iso6391.toLowerCase()}.svg`}
              className="h-auto w-6"
              alt={language.displayName}
            />

            {language.iso6391}
          </a>
        )}
      </Menu.Item>
    )
  })

  return (
    <>
      <Menu as="div" className="relative inline-block">
        {({ open }) => (
          <>
            <div className="flex h-full items-center">
              <Menu.Button className="flex items-center gap-1 uppercase">
                {props.locale}
                <ArrowDownBigIcon className={`h-5 w-5 ${open ? 'rotate-180' : ''}`} />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute z-[60] mt-2 w-[180px] origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ltr:right-0 rtl:left-0">
                <div className="grid grid-cols-2 px-1 py-1">{localesList}</div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </>
  )
}
